import {theme} from '@miro-site/design-tokens'

export const resetStyles = {
  transition: `color ${theme.animation.transitionDuration}, borderColor ${theme.animation.transitionDuration}`,
  display: 'inline-block',
  border: 'none',
  textDecoration: 'none',
  cursor: 'pointer',
}

const defaultLink = {
  borderBottom: `1px solid currentColor`,
  transition: `border-color ${theme.animation.transitionDuration}`,
  '&:hover': {
    borderColor: 'transparent',
  },
}

const linkWithArrow = {
  '&:hover': {
    '.link-text': {
      borderColor: 'transparent',
    },
  },
  '.link-text': {
    display: 'inline',
    borderBottom: `1px solid currentColor`,
    transition: `border-color ${theme.animation.transitionDuration}`,
  },
  '.link-arrow': {
    marginLeft: 5,
  },
}

export const arrowLinkVariants = {
  default: {
    ...linkWithArrow,
    fontWeight: 500,
    '&:focus': {
      ...theme.focus.outlines.withOffset,
    },
  },
  regular: {
    ...linkWithArrow,
    fontWeight: 400,
    '&:focus': {
      ...theme.focus.outlines.withOffset,
    },
  },
  richText: {
    display: 'inline',
    fontWeight: 400,
    border: '1px solid transparent',
    ...linkWithArrow,
    '&:focus': {
      ...theme.focus.outlines.default,
    },
  },
}

export const variants = {
  default: {
    ...defaultLink,
    fontWeight: 500,
    '&:focus': {
      ...theme.focus.outlines.withOffset,
    },
  },
  regular: {
    ...defaultLink,
    fontWeight: 400,
    '&:focus': {
      ...theme.focus.outlines.withOffset,
    },
  },
  richText: {
    display: 'inline',
    fontWeight: 400,
    border: '1px solid transparent',
    ...defaultLink,
    '&:focus': {
      ...theme.focus.outlines.default,
    },
  },
}

export const sizes = {
  small: {
    fontSize: 14,
    lineHeight: 20,
  },
  default: {
    fontSize: 18,
    lineHeight: 24,
  },
  medium: {
    fontSize: 16,
    lineHeight: 24,
  },
  large: {
    fontSize: 24,
    lineHeight: 32,
  },
}

export const colors = {
  indigo: {
    color: theme.colors.primaryIndigo,
  },
  default: {
    color: theme.colors.primaryBlue,
    '&:hover': {
      color: theme.colors.primaryBlueHover,
    },
  },
  white: {
    color: theme.colors.primaryWhite,
    '&:hover': {
      color: theme.colors.outspoken,
    },
  },
  pink: {color: theme.colors.human},
  yellow: {color: theme.colors.outspoken},
}

export default {
  resetStyles,
  sizes,
  colors,
  variants,
  arrowLinkVariants,
}
